import React from 'react';
import InfoModal from './infoModal';

function EducationModal(props) {
  return (
    <InfoModal title="Education" {...props}>
      <article className="info-entry">
        <p className="info-kicker">Undergraduate</p>
        <h3 className="info-org">Queen's University</h3>
        <p className="info-meta">Kingston, Ontario</p>
        <ul className="info-list">
          <li>
            Bachelor of Applied Science
            <ul>
              <li>Specialization in Software Engineering</li>
            </ul>
          </li>
        </ul>
      </article>

      <article className="info-entry">
        <p className="info-kicker">Secondary</p>
        <h3 className="info-org">Crescent School</h3>
        <p className="info-meta">Toronto, Ontario</p>
        <ul className="info-list">
          <li>Headmaster’s Honour Roll Distinction (&gt;93%)</li>
        </ul>
      </article>
    </InfoModal>
  );
}

export default EducationModal;
